import { Component, OnInit } from '@angular/core';
import { FeedbackService } from '../../services/feedback.service';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-fbqtbank',
  templateUrl: './fbqtbank.component.html',
  styleUrls: ['./fbqtbank.component.scss'],
  providers:[FeedbackService]
})
export class FbqtbankComponent implements OnInit {

  
    ddlfeed=[];
    memberdetails:any[]=[];
    classdetails:any[]=[];
    closeResult: string;
    fedopts:any[]=[];
   
    student:boolean=true;
    staff:boolean=false;
    memberdash:any={};
    objfedhead:any={};
    objquesthead:any={};
    objquestopt:any={};
    selfed:any='0';
    
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    constructor(private http: HttpClient, private liservice: FeedbackService,private modalService: NgbModal) { }
  
    open(content) {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
  
  
  
    ngOnInit(): void {
      
     //  this.getmemberdetails('selstu','');
     //  this.getclassdetails();
     //  this.memberdashcnts('dashcnts');
     this.getfeedbackquestbank();
     this.getfedbackhead(0,'selallhead');
    }
  
    getfedbackhead(fbid,oprtype) {
      this.liservice.getfeedbackqttype(fbid,oprtype)
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
              if(oprtype=='selallhead')
              {
              this.memberdetails = resultArray;
              this.objquesthead.fbqtypeid=resultArray[0].fbqttypeid;
              }
              
              
              
          },
          error => console.log("Error :: " + error)
          )
    }
    getfeedbackquestbank() {
      this.liservice.getfeedbackquestbank()
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
              
              this.classdetails = resultArray;
             
              
              
              
          },
          error => console.log("Error :: " + error)
          )
    }


    
   openquesthead(content,objdata,cmd) {
     if(cmd=='insert')
     {
       this.objquesthead={};
       //this.objquesthead.fbqttypeid='0';
       this.objquesthead.oprtype='insert';
       this.objquesthead.fbqdis='';
       this.objquesthead.fbqid='0'
 
     }
 
     else if(cmd=='update')
     {
       this.objquesthead=objdata;
       this.objquesthead.oprtype='update';
     }
     
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
       
      
     }
     this.modalRef=this.modalService.open(content,this.modalOptions);
     
     this.modalRef.result.then((result) => {
    
          
       }, (reason) => {
           
       });
   }


  

savefeedbackquestionhead()
{
//console.log('catsave',this.genmodel);
 this.liservice.savefeedbackquestbank(this.objquesthead)
     .subscribe(
     result => {
         console.log('SavegenmasDetails', result);
         //this.suppliers = resultArray;
         alert(result.message);
         if(result.status=='Success')
         {
           let localmodref=this.modalRef;
           localmodref.close();
           this.getfeedbackquestbank();

         }
        else
        {

        }
     },
     error =>{ alert('Error While saving...');}
     )
}


getfeedbackquestionhead(fbid,fbqtid,oprtype) {
 this.liservice.getfeedbackquestionhead(fbid,fbqtid,oprtype)
     .subscribe(
     resultArray => {
         console.log('members-result', resultArray);
         this.classdetails = resultArray;
         
     },
     error => console.log("Error :: " + error)
     )
}

getfeedbackopts(fbid,fbqtid,oprtype) {
 this.liservice.getfeedbackopts(fbid,fbqtid,oprtype)
     .subscribe(
     resultArray => {
         console.log('options', resultArray);
         this.fedopts = resultArray;
         
     },
     error => console.log("Error :: " + error)
     )
}


delfeedbackopts(fbid) {
 this.liservice.delfeedbackopts(fbid)
 .subscribe(
   result => {
       console.log('SavegenmasDetails', result);
       //this.suppliers = resultArray;
       alert(result.message);
      // this.objquestopt.qtrespnm='';
       this.getfeedbackopts(this.selfed,this.objquestopt.fbqtid,'selbyid');
     
   },
   error =>{ alert('Error While saving...');}
   )
}
  
  
   
  
  
   
  }
